// Copyright 2018 Sorama B.V.

import {
    FrequencySpectrumSet,
    GenericMeasurement,
    SpectrumSetAnalysisProperties,
    TimeSignal,
    TimeSignalAnalysisProperties,
} from "datatypes/SoramaWebApi";

export abstract class ISpectralProcessingService {
    /**
     * Get time signal for the given measurement
     * @param measurement Measurement to get the measurement data for the spectra from
     * @param timeRanges Time interval for each of the spectra
     * @param computationProgressCallback Optional progress callback which will receive periodic progress updates
     */
    abstract getTimeSignals(
        measurement: GenericMeasurement,
        properties: TimeSignalAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<TimeSignal[]>;

    /**
     * Get spectra for the given measurement
     * @param measurement Measurement to get the measurement data for the spectra from
     * @param timeRanges Time interval for each of the spectra
     * @param computationProgressCallback Optional progress callback which will receive periodic progress updates
     */
    abstract getSpectrumSet(
        measurement: GenericMeasurement,
        properties: SpectrumSetAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<FrequencySpectrumSet>;

    abstract getSensorRMSValues(measurement: GenericMeasurement): Promise<number[]>;
}
